import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from "reactstrap";


class ModalAlteracoes extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }
    render() {

        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>
                <ModalHeader toggle={this.props.toggleModalAlteracoes}>Alterações não salvas</ModalHeader>
                <ModalBody>
                    <p>Existem alterações que não foram salvas. Deseja descartá-las?</p>
                    {this.props.exibeLista && (
                        <ul>
                            {this.props.listaPendencias.map((item, index) => {
                                return <li key={index}>{item}</li>
                            })}
                        </ul>
                    )}
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" onClick={() => this.props.callBackDescartar ? this.props.callBackDescartar() : window.history.go(-1)}>descartar</Button>
                    {' '}
                    <Button color="secondary" onClick={(e) => this.props.callBackDescartar ? this.props.toggle(null) : this.props.toggle(e)}>voltar</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default ModalAlteracoes;